import { render } from "./EditPartnerPage.vue?vue&type=template&id=292ba00f"
import script from "./EditPartnerPage.vue?vue&type=script&lang=js"
export * from "./EditPartnerPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__